export class DismissLoader {
  public static readonly type = '[Loader] DismissLoader';
}
